<template>
  <div v-if="menu.Categories">
    <div v-if="menu.Categories.length > 0">
      <section :id="'section-search'" :style="getSearchSectionStyle()">
        <div
          class="row search-product justify-content-center align-items-center"
          :style="getSearchContainerRolldStyles()"
        >
          <div class="col-8 mt-1" :class="getSearchBoxStyles()">
            <i
              class="fa fa-search new-fa-search"
              aria-hidden="true"
              :style="getSearchIconRolldStyles()"
            ></i>
            <input
              type="text"
              v-model="filterText"
              class="form-input shadow"
              :style="getSearchRolldStyles()"
              :placeholder="getSearchProductsPlaceholder"
            />
          </div>
          <div class="col-4">
            <order-type-select />
          </div>
        </div>
      </section>
      <section
        v-for="(category, cIndex) in menu.Categories"
        :key="category.ID"
        :id="'section-' + category.ID"
      >
        <template
          v-if="!UnavailableCategories.includes(category.ID.toString())"
        >
          <div class="row" v-if="porductToShow(category).length > 0">
            <div
              class="col-sm-12 category-title"
              :style="desktopStyles.textColour"
            >
              <h2
                id="combos"
                v-html="formatCategoryTitle(getCategoryName(category))"
              ></h2>
              <div
                :ref="'categoryDescription_' + cIndex"
                v-html="getCategoryDescription(category)"
              ></div>
            </div>
          </div>
          <div class="row menu-content">
            <div
              v-for="(product, index) in porductToShow(category)"
              :key="product.ID"
              class="col-sm-12 col-md-12"
              :class="productClass"
              :style="getProductRolldStyle(index)"
            >
              <Product
                :product="menu.Products[product.ProductID]"
                :modifiers="menu.ModifierGroups"
                :category="product"
                :key="product.ID"
                :sectionId="category.ID"
                :parent-category="category"
                :status="getStatus(product)"
              />
            </div>
          </div>
        </template>
      </section>
      <div v-if="getcountproduct == 0">
        {{ $t("message.Nomatchingproducts") }}
      </div>
    </div>
    <div v-else>
      <message />
    </div>
    <confirmationModal></confirmationModal>
  </div>
</template>

<script>
import Product from "./Product";
import shared from "../../../sharedscripts/shop/products/ProductList";
import Message from "../../shared/Message";
import { $$ } from "./../../../sharedscripts/OO_jquery";
import { mapGetters } from "vuex";
import confirmationModal from "../../confirmationModal.vue";
import OrderTypeSelect from "@/components/shared/OrderTypeSelect.vue";
export default {
  name: "ProductList",
  components: { OrderTypeSelect, Product, Message, confirmationModal },
  props: {
    menu: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      productClass: "col-xl-6",
      once: true,
      filterText: null,
    };
  },
  mounted() {
    if (this.$refs && this.$refs.categoryDescription_0) {
      var element = document.getElementById("aside-top");
      if (element) {
        if (this.isRolldStore()) {
          element.style.height = `${
            143 + this.$refs.categoryDescription_0[0].clientHeight
          }px`;
        }
      }
    }
  },
  updated() {
    if (this.isWC()) {
      this.calcProductClass();
      if (this.once) {
        window.addEventListener("resize", this.calcProductClass);
        this.once = false;
      }
    }
  },

  computed: {
    ...mapGetters([
      "getDietarySelection",
      "desktopStyles",
      "viewConfig",
      "UnavailableCategories",
      "productStatuses",
    ]),
    getSearchProductsPlaceholder() {
      return this.$t("message.SearchProducts");
    },
    getcountproduct() {
      var count = 0;
      if (this.menu.Categories && this.menu.Categories.length > 0) {
        this.menu.Categories.forEach((element) => {
          if (element && element.SubMenuItems) {
            var items = this.porductToShow(element);
            count += items.length;
          }
        });
      }
      return count;
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
  },
  methods: {
    ...shared.methods,
    calcProductClass() {
      var containerWidth = $$(".oo-module").outerWidth();
      if (containerWidth > 992) {
        this.productClass = "col-xl-6";
      } else {
        this.productClass = "col-xl-12";
      }
      this.$emit("update-containerWidth", containerWidth);
    },
    porductToShow(category) {
      var items = category.SubMenuItems.filter(
        (p) =>
          !this.filterText ||
          p.Name.toUpperCase().indexOf(this.filterText.toUpperCase()) > -1
      );
      if (this.getDietarySelection.Allergy.length > 0) {
        items = items.filter(
          (p) =>
            this.getDietarySelection.Allergy.filter((a1) =>
              p.ProductAllergy.some((a2) => a2 == a1.Id)
            ).length == this.getDietarySelection.Allergy.length
        );
      }
      if (this.getDietarySelection.Intolerance.length > 0) {
        items = items.filter(
          (p) =>
            this.getDietarySelection.Intolerance.filter((a1) =>
              p.ProductIntolerance.some((a2) => a2 == a1.Id)
            ).length == this.getDietarySelection.Intolerance.length
        );
      }
      if (this.getDietarySelection.Preference.length > 0) {
        items = items.filter(
          (p) =>
            this.getDietarySelection.Preference.filter((a1) =>
              p.ProductPreference.some((a2) => a2 == a1.Id)
            ).length == this.getDietarySelection.Preference.length
        );
      }
      return items;
    },
    getProductRolldStyle(index) {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push({ "border-right": "1px solid #d9d9d9" });
        styles.push({ "border-bottom": "1px solid #d9d9d9" });
        if (index == 0 || index == 1) {
          styles.push({ "border-top": "1px solid #d9d9d9" });
        }
        styles.push({ height: "215px" });
      }
      return styles;
    },
    getSearchIconRolldStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push({ "margin-top": "13px" });
        styles.push(this.desktopStyles.MagnifyColor);
      }
      return styles;
    },
    getSearchRolldStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push(this.desktopStyles.primaryBodyBackground);
        styles.push({ "margin-top": "7px" });
      }
      return styles;
    },
    getSearchContainerRolldStyles() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push({ "border-top": "1px solid #d9d9d9" });
        styles.push({ "border-bottom": "1px solid #d9d9d9" });
        styles.push({ "margin-top": "-10px" });
        styles.push({ "margin-bottom": "10px" });
      }
      return styles;
    },
    getSearchSectionStyle() {
      var styles = [];
      if (this.isRolldStore()) {
        styles.push({ width: "150%" });
      }
      return styles;
    },
    getStatus(product) {
      return this.productStatuses[product.ProductID] || 0;
    },
    getSearchBoxStyles() {
      if (this.showNewUi) {
        return "new-search-box";
      }
      return "search-box";
    },
  },
};
</script>
